import {Injectable} from '@angular/core';
import {FrontendDocument, FrontendStatusEnum} from '@nachdigal';
import {TranslateService} from '@ngx-translate/core';
import {Subject} from 'rxjs';
import {FragebogenTypPipe} from '../../fragebogen/fragebogen-typ.pipe';
import {TAB, TabEnumName} from '@utils-lib';

@Injectable({
    providedIn: 'root'
})
export class SearchFilterService {

    public search$ = new Subject<FrontendDocument[]>();

    constructor(private readonly translateService: TranslateService) {
    }

    private static isAntragSent(document: FrontendDocument): boolean {
        return document.status === FrontendStatusEnum.SendingFinalized || document.status === FrontendStatusEnum.SendingSuccessful;
    }

    public publish(value: FrontendDocument[]): void {
        this.search$.next(value);
    }

    public getFilteredDocuments(
        activeTab: TabEnumName,
        documents: FrontendDocument[],
        searchValue: string,
        activeSearch: boolean): FrontendDocument[] {
        return this.getDocuments(activeTab, documents, searchValue, activeSearch);
    }

    public getDocuments(tab: TabEnumName, documents: FrontendDocument[], searchValue: string, activeSearch: boolean): FrontendDocument[] {
        const filteredDocuments = documents
            .filter((document: FrontendDocument) => tab === TAB.GESENDET ?
                SearchFilterService.isAntragSent(document) :
                !SearchFilterService.isAntragSent(document))
            .filter((document: FrontendDocument) => this.isSearchActive(document, searchValue, activeSearch));
        return this.sortFilteredDocuments(tab, filteredDocuments);
    }

    private isSearchActive(document: FrontendDocument, searchValue: string, isActive: boolean): boolean {
        if (isActive) {
            const appName = this.getFullTypName(document.element_of_order?.app_name);
            return document.client_name?.toLowerCase().includes(searchValue.toLowerCase(), 0)
                || document.element_of_order?.consultant_number?.includes(searchValue, 0)
                || document.element_of_order?.master_client_number?.includes(searchValue, 0)
                || appName.toLowerCase().includes(searchValue.toLowerCase(), 0);
        }
        return true;
    }

    private sortFilteredDocuments(tab: TabEnumName, filteredDocuments: FrontendDocument[]): Array<FrontendDocument> {
        filteredDocuments.forEach((doc: FrontendDocument) => {
            if (!doc.client_name) {
                doc.client_name = 'Mandantenname nicht bekannt';
            }
        });
        return filteredDocuments.sort((a: FrontendDocument, b: FrontendDocument) => {
            if (tab === TAB.ENTWUERFE) {
                return (a.last_changed_on < b.last_changed_on) ? 1 : -1;
            } else {
                return (a.transfer_date < b.transfer_date) ? 1 : -1;
            }
        });
    }

    private getFullTypName(appName: string): string {
        const fragebogenTypPipe = new FragebogenTypPipe(this.translateService);
        return fragebogenTypPipe.transform(appName);
    }
}
